import {StyleSheet} from 'react-native';
import font from '@buncha/appStyles/style/font';

export const styles = StyleSheet.create({
  rowFlex: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  jcc: {
    flexDirection: 'column',
    justifyContent: 'center',
    padding: 2,
  },
  flexBox: {flex: 1, alignItems: 'flex-start', marginLeft: 10},
  nameTypo: {
    ...font.FontSize.fontH5,
    textAlign: 'left',
    alignItems: 'center',
  },
});
